import {QuestionMatchesQuality} from '~/features/Ask/QuestionMatchesQuality';

export const QuestionMatchesQualityScene = () => {
  return <QuestionMatchesQuality />;
};
